import { useDisclosure, useToast } from "@chakra-ui/react";
import { FormHandler } from "@raiden/library/components/ReactHookForm/FormHandler";
import {
  apiGetErrorDetail,
  apiGetErrorFields,
} from "@raiden/library/helpers/api";
import generateApiUri from "@raiden/library/libraries/utils/generateApiUri";
import generatePampaUri from "@raiden/library/libraries/utils/generatePampaUri";
import encodeFormData from "@splitfire-agency/raiden-library/dist/libraries/utils/encodeFormData";

/**
 * @typedef {object} HoldersUpdateCoverFormValues
 * @property {object} data
 * @property {object} data.id_card
 * @property {any} data.id_card.transformations
 * @property {any} id_card
 */

/**
 * @param {object} params
 * @param {import("@raiden/library/types/Holder").Holder} params.holder
 *
 * @returns {HoldersUpdateCoverFormValues}
 */
export function holderUpdateCovergetDefaultValues({ holder }) {
  const values = {
    data: {
      id_card: {
        transformations: holder.id_card?.transformations,
      },
    },
    id_card: holder.id_card
      ? generatePampaUri({
          image: holder.id_card,
          mode: "crop",
        })
      : undefined,
  };
  return values;
}

/**
 * @typedef {object} Props
 * @property {import("@raiden/library/types/Holder").Holder} holder
 * @property {({response}) => void} onSuccess
 * @property {(params: {isOpen: boolean, onOpen: () => void, onClose: () => void, form: import("react-hook-form").UseFormReturn<HoldersUpdateCoverFormValues>, isLoading: boolean, submit: () => void}) => import("react").ReactElement} render
 *
 * @param {Props} props
 */
export default function HoldersUpdateCoverHandler({
  holder,
  onSuccess,
  render,
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const toast = useToast();

  return (
    <FormHandler
      withForm={false}
      defaultValues={holderUpdateCovergetDefaultValues({ holder })}
      getRequestParams={({ values }) => ({
        url: generateApiUri({
          id: "@holders.update",
          parameters: {
            holderId: holder.id,
          },
          query: {
            fields: ["holder.id_card"],
          },
        }),
        init: {
          method: "POST",
          body: encodeFormData(values),
        },
        options: {
          inputMode: "formData",
        },
      })}
      onSuccess={({ response }) => {
        onSuccess({ response });
      }}
      onError={({ response, form }) => {
        form.clearErrors();
        toast({
          status: "error",
          position: "bottom-right",
          title: apiGetErrorDetail({ error: response }),
          description: apiGetErrorFields({ error: response })?.id_card.join(
            " ",
          ),
        });
      }}
      children={({ form, submit, isLoading }) =>
        render({
          isOpen,
          onOpen,
          onClose,
          form,
          submit,
          isLoading,
        })
      }
    />
  );
}
